import { Autocomplete, TextField } from '@mui/material';

type Props = {
    label: string;
    name: string;
    value?: string[];
    required?: boolean;
    touched?: boolean;
    errors?: string | never[] | string[] | undefined;
    disabled?: boolean;
    onChangeValue: (value: string[]) => void;
    onBlur?: () => void;
};

const MultipleEmailsField = ({
    label,
    name,
    value,
    required,
    touched,
    errors,
    disabled,
    onChangeValue,
    onBlur,
}: Props) => {
    return (
        <Autocomplete
            multiple
            freeSolo
            disabled={disabled}
            options={[]}
            value={value || []}
            onChange={(_event, newValue: string[]) => onChangeValue(newValue)}
            onBlur={onBlur}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    name={name}
                    required={required}
                    helperText={touched ? errors : ''}
                    error={touched && Boolean(errors)}
                    sx={{
                        '& label.Mui-focused': {
                            color: 'primary.main',
                        },
                        '& .MuiInput-underline:after': {
                            borderBottomColor: 'primary.main',
                        },
                        '& .MuiFilledInput-underline:after': {
                            borderBottomColor: 'primary.main',
                        },
                        '& .MuiOutlinedInput-root': {
                            '&.Mui-focused fieldset': {
                                borderColor: 'primary.main',
                            },
                        },
                    }}
                />
            )}
        />
    );
};

export default MultipleEmailsField;